import carrierRepository from "../repositories/CarrierRepository";
import { buildSearchParams } from "../utils/requestHelpers";
import { getMcleodType } from "../utils/mcleodNameHelpers";

export class CarrierService {
  static FindCarrier(instance, searchParams) {
    const repo = new carrierRepository;
    const params = buildSearchParams(searchParams);

    return repo.findCarrier(instance, params).then();
  }

  static FindCarriers(instance, searchParams) {
    const repo = new carrierRepository;
    const params = buildSearchParams(searchParams);

    return repo.findCarriers(instance, params).then();
  }

  static FindCarriersAdvanced(instance, searchParams) {
    const repo = new carrierRepository;
    const params = buildSearchParams(searchParams);

    return repo.findCarriersAdvanced(instance, params).then();
  }

  static HomeLocationSearch(instance, searchParams) {
    const repo = new carrierRepository;
    const params = buildSearchParams(searchParams);

    return repo.homeLocationSearch(instance, params).then();
  }

  static GetCarrierSavedSearchByUser(instance, userId) {
    const repo = new carrierRepository;

    return repo.getCarrierSavedSearchByUser(instance, userId);
  }

  static CreateCarrierSavedSearch(instance, payload) {
    const repo = new carrierRepository;

    return repo.createCarrierSavedSearch(instance, payload).then();
  }

  static UpdateCarrierSavedSearch(instance, payload) {
    const repo = new carrierRepository;

    return repo.updateCarrierSavedSearch(instance, payload).then();
  }

  static GetCarrier(instance, carrierId) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        id: carrierId
      }
    );

    return repo.getCarrier(instance, params).then();
  }

  static UpdateCarrier(instance, payload) {
    const repo = new carrierRepository;

    return repo.updateCarrier(instance, payload).then();
  }

  static UpdateCarrierDynamic(instance, carrierId, type, value) {
    const repo = new carrierRepository;

    const payload = {
      id: carrierId,
      drsPayee: {
        [getMcleodType(type)]: value,
        id: carrierId,
        __type: "drs_payee",
        company_id: "TMS"
      },
      __type: "payee",
      company_id: "TMS"
    };

    return repo.updateCarrierDynamic(instance, payload).then();
  }

  static GetCarrierEquipmentTypes(instance) {
    const repo = new carrierRepository;

    return repo.getCarrierEquipmentTypes(instance).then();
  }

  static GetCarrierEquipment(instance, carrierId) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        payeeId: carrierId
      }
    );

    return repo.getCarrierEquipment(instance, params).then();
  }

  static CreateCarrierEquipment(instance, payload) {
    const repo = new carrierRepository;

    return repo.createCarrierEquipment(instance, payload).then();
  }

  static UpdateCarrierEquipment(instance, payload) {
    const repo = new carrierRepository;

    return repo.updateCarrierEquipment(instance, payload).then();
  }

  static DeleteCarrierEquipment(instance, equipmentId) {
    const repo = new carrierRepository;

    return repo.deleteCarrierEquipment(instance, equipmentId).then();
  }

  static UpdateCarrierInsurance(instance, payload) {
    const repo = new carrierRepository;

    return repo.updateCarrierInsurance(instance, payload).then();
  }

  static GetCarrierContacts(instance, carrierId) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        payeeId: carrierId,
        onlyActiveContacts: true
      }
    );

    return repo.getCarrierContacts(instance, params).then();
  }

  static CreateCarrierContact(instance, payload) {
    const repo = new carrierRepository;

    return repo.createCarrierContact(instance, payload).then();
  }

  static UpdateCarrierContact(instance, payload) {
    const repo = new carrierRepository;

    return repo.updateCarrierContact(instance, payload).then();
  }

  static GetCarrierLoads(instance, carrierId, lookBackDays) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        payeeId: carrierId,
        lookBackDays: lookBackDays
      }
    );

    return repo.getCarrierLoads(instance, params).then();
  }

  static GetCarriersByOrigin(instance, searchParams) {
    const repo = new carrierRepository;
    const params = buildSearchParams(searchParams);

    return repo.getCarriersByOrigin(instance, params).then();
  }

  static GetCarriersByLane(instance, searchParams) {
    const repo = new carrierRepository;
    const params = buildSearchParams(searchParams);

    return repo.getCarriersByLane(instance, params).then();
  }

  static GetCarriersByState(instance, searchParams) {
    const repo = new carrierRepository;
    const params = buildSearchParams(searchParams);

    return repo.getCarriersByState(instance, params).then();
  }

  static GetCarrierExtraPay(instance, orderId) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        orderId: orderId
      }
    );

    return repo.getCarrierExtraPay(instance, params).then();
  }

  static CreateCarrierExtraPay(instance, payload) {
    const repo = new carrierRepository;

    return repo.createCarrierExtraPay(instance, payload).then();
  }

  static UpdateCarrierExtraPay(instance, payload) {
    const repo = new carrierRepository;

    return repo.updateCarrierExtraPay(instance, payload).then();
  }

  static DeleteCarrierExtraPay(instance, accessorialToDelete) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        id: accessorialToDelete.accessorialId
      }
    );

    return repo.deleteCarrierExtraPay(instance, params, accessorialToDelete).then();
  }

  static GetCarrierExtraPayTypes(instance) {
    const repo = new carrierRepository;

    return repo.getCarrierExtraPayTypes(instance).then();
  }

  static GetCarrierCommissionValues(instance) {
    const repo = new carrierRepository;

    return repo.getCarrierCommissionValues(instance).then();
  }

  static GetLoadTotals(instance, loadId) {
    const repo = new carrierRepository;
    return repo.getLoadTotals(instance, loadId).then();
  }

  static GetLoadOffers(instance, orderId, timeFrameDays) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        orderId: orderId,
        includeScoreCard: true,
        timeFrameDays: timeFrameDays
      }
    );

    return repo.getLoadOffers(instance, params).then();
  }

  static CreateCarrierOffer(instance, payload) {
    const repo = new carrierRepository;

    return repo.createCarrierOffer(instance, payload).then();
  }

  static UpdateCarrierOffer(instance, payload) {
    const repo = new carrierRepository;

    return repo.updateCarrierOffer(instance, payload).then();
  }

  static GetDeclineReasons(instance) {
    const repo = new carrierRepository;
    return repo.getDeclineReasons(instance).then();
  }

  static GetPreferredLanes(instance, carrierId) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        carrierId: carrierId,
        onlyActiveRows: true
      }
    );

    return repo.getPreferredLanes(instance, params).then();
  }

  static GetPreferredLane(instance, laneId) {
    const repo = new carrierRepository;
    return repo.getPreferredLane(instance, laneId).then();
  }

  static CreatePreferredLane(instance, payload) {
    const repo = new carrierRepository;

    return repo.createPreferredLane(instance, payload).then();
  }

  static UpdatePreferredLane(instance, payload) {
    const repo = new carrierRepository;

    return repo.updatePreferredLane(instance, payload).then();
  }

  static ExpirePreferredLane(instance, payload) {
    const repo = new carrierRepository;

    return repo.expirePreferredLane(instance, payload).then();
  }

  static ExpireAllPreferredLane(instance, payload) {
    const repo = new carrierRepository;

    return repo.expireAllPreferredLane(instance, payload).then();
  }

  static GetPostedTrucks(instance, carrierId) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        carrierId: carrierId
      }
    );

    return repo.getPostedTrucks(instance, params).then();
  }

  static CreatePostedTruck(instance, payload) {
    const repo = new carrierRepository;

    return repo.createPostedTruck(instance, payload).then();
  }

  static UpdatePostedTruck(instance, payload) {
    const repo = new carrierRepository;

    return repo.updatePostedTruck(instance, payload).then();
  }

  static ExpirePostedTruck(instance, payload) {
    const repo = new carrierRepository;

    return repo.expirePostedTruck(instance, payload).then();
  }

  static ExpireAllPostedTruck(instance, payload) {
    const repo = new carrierRepository;

    return repo.expireAllPostedTruck(instance, payload).then();
  }

  static GetLaneFreightMatches(instance, searchParams) {
    const repo = new carrierRepository;
    const params = buildSearchParams(searchParams);

    return repo.getLaneFreightMatches(instance, params).then();
  }

  static GetCarrierFreightMatches(instance, searchParams) {
    const repo = new carrierRepository;
    const params = buildSearchParams(searchParams);

    return repo.getCarrierFreightMatches(instance, params).then();
  }

  static GetLoadFreightMatches(instance, searchParams) {
    const repo = new carrierRepository;
    const params = buildSearchParams(searchParams);

    return repo.getLoadFreightMatches(instance, params).then();
  }

  static GetNetworkFreightMatches(instance, searchParams) {
    const repo = new carrierRepository;
    const params = buildSearchParams(searchParams);

    return repo.getNetworkFreightMatches(instance, params).then();
  }

  static CreateNetworkMatchingRemoved(instance, payload) {
    const repo = new carrierRepository;

    return repo.createNetworkMatchingRemoved(instance, payload).then();
  }

  static DeleteNetworkMatchingRemoved(instance, searchParams) {
    const repo = new carrierRepository;
    const params = buildSearchParams(searchParams);

    return repo.deleteNetworkMatchingRemoved(instance, params).then();
  }

  static GetCarrierQualifications(instance, carrierId, movementId) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        carrierId: carrierId,
        movementId: movementId
      }
    );

    return repo.getCarrierQualifications(instance, params).then();
  }

  static BookLoad(instance, payload) {
    const repo = new carrierRepository;

    return repo.bookLoad(instance, payload).then();
  }

  static GetFuelSurcharge(instance) {
    const repo = new carrierRepository;

    return repo.getFuelSurcharge(instance).then();
  }

  static CreateAccessorialComcheck(instance, payload) {
    const repo = new carrierRepository;

    return repo.createAccessorialComcheck(instance, payload).then();
  }

  static CreateFuelAdvanceComcheck(instance, payload) {
    const repo = new carrierRepository;

    return repo.createFuelAdvanceComcheck(instance, payload).then();
  }

  static CreatePaidInFullComcheck(instance, payload) {
    const repo = new carrierRepository;

    return repo.createPaidInFullComcheck(instance, payload).then();
  }

  static GetComcheckFuelCalc(instance, carrierId, movementId, requestedAmount) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        carrierId: carrierId,
        movementId: movementId,
        requestedAmount: requestedAmount
      }
    );

    return repo.getComcheckFuelCalc(instance, params).then();
  }

  static GetComcheckPifCalc(instance, carrierId, movementId) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        carrierId: carrierId,
        movementId: movementId
      }
    );

    return repo.getComcheckPifCalc(instance, params).then();
  }

  static GetIssuedComchecks(instance, carrierId, orderId) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        carrierId: carrierId,
        orderId: orderId
      }
    );

    return repo.getIssuedComchecks(instance, params).then();
  }

  static GetCarrierNetwork(instance, userId) {
    const repo = new carrierRepository;

    return repo.getCarrierNetwork(instance, userId).then();
  }

  static AddCarrierLead(instance, payload) {
    const repo = new carrierRepository;

    return repo.addCarrierLead(instance, payload).then();
  }

  static RemoveCarrierLead(instance, payload) {
    const repo = new carrierRepository;

    return repo.removeCarrierLead(instance, payload).then();
  }

  static RemoveCarrierRelationship(instance, payload) {
    const repo = new carrierRepository;

    return repo.removeCarrierRelationship(instance, payload).then();
  }

  static GetNetworkStatus(instance, carrierId, userId) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        carrierId: carrierId,
        userId: userId
      }
    );

    return repo.getNetworkStatus(instance, params).then();
  }

  static AddManualLead(instance, payload) {
    const repo = new carrierRepository;

    return repo.addManualLead(instance, payload).then();
  }

  static AddManualOpen(instance, payloadOpen) {
    const repo = new carrierRepository;

    return repo.addManualOpen(instance, payloadOpen).then();
  }

  static AddManualRelat(instance, payload) {
    const repo = new carrierRepository;

    return repo.addManualRelat(instance, payload).then();
  }

  static GetReasonsCode(instance) {
    const repo = new carrierRepository;

    return repo.getReasonCode(instance);
  }

  static GetCallInStatuses(instance) {
    const repo = new carrierRepository;

    return repo.getCallInStatuses(instance);
  }

  static GetCallInsByOrder(instance, orderId) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        orderId: orderId
      }
    );

    return repo.getCallInsByOrder(instance, params);
  }

  static CreateCallIn(instance, payload) {
    const repo = new carrierRepository;

    return repo.createCallIn(instance, payload).then();
  }

  static UpdatesStopsTimes(instance, payload) {
    const repo = new carrierRepository;

    return repo.updatesStopsTimes(instance, payload).then();
  }

  static UpdateToDISStatus(instance, movementId) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        movementId: movementId,
        NewBrokerageStatus: "DIS"
      }
    );

    return repo.updateToDISStatus(instance, params).then();
  }

  static GetMilesToNextStop(instance, latitude, longitude, stopId) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        stopid: stopId,
        latitude: latitude,
        longitude: longitude
      }
    );

    return repo.getMilesToNextStop(instance, params).then();
  }

  static GetLoadsByRegion(instance, regionId, customerId) {
    const repo = new carrierRepository;

    return repo.getLoadsByRegion(instance, regionId, customerId).then();
  }

  static GetLoadsByUser(instance, userId) {
    const repo = new carrierRepository;

    return repo.getLoadsByUser(instance, userId).then();
  }

  static UpdateOfferAction(instance, payload) {
    const repo = new carrierRepository;

    return repo.updateOfferAction(instance, payload).then();
  }

  static RemoveCarrierLoad(instance, payload) {
    const repo = new carrierRepository;

    return repo.removeCarrierLoad(instance, payload).then();
  }

  static ClearLoads(instance, payload) {
    const repo = new carrierRepository;

    return repo.clearLoads(instance, payload).then();
  }

  static UnclearLoads(instance, payload) {
    const repo = new carrierRepository;

    return repo.unclearLoads(instance, payload).then();
  }

  static GetCarrierScorecard(instance, carrierId, timeFrameDays) {
    const repo = new carrierRepository;
    const params = buildSearchParams(
      {
        carrierId: carrierId,
        timeFrameDays: timeFrameDays
      }
    );

    return repo.getCarrierScorecard(instance, params).then();
  }

  static GetCarrierManagers(instance) {
    const repo = new carrierRepository;

    return repo.getCarrierManagers(instance).then();
  }

  static UpdateStop(instance, payload, payeeId) {
    const repo = new carrierRepository;

    return repo.updateStop(instance, payload, payeeId).then();

  }
  static ClearTimeStop(instance, payload, payeeId, lastStopOrderSequence) {
    const repo = new carrierRepository;

    return repo.clearTimeStop(instance, payload, payeeId, lastStopOrderSequence).then();
  }

  static UpdateMaxPay(instance, payload) {
    const repo = new carrierRepository;

    return repo.updateMaxPay(instance, payload).then();
  }

  static UpdateDispatch(instance, payload) {
    const repo = new carrierRepository;

    return repo.updateDispatch(instance, payload).then();
  }
}